export const GET_LIST = 'COMPONENTS/get_list';
export const UPDATE_COMPONENT = 'COMPONENTS/UPDATE_COMPONENT';

export const FORM_DATA = {
  garbage_fee : "",
  mayor_permit : "",
  occupational_fee : "",
  other_fee : "",
  penalty : "",
  plate_sticker : "",
  processing_fee : "",
  surcharge : "",
  tricycle_permit_number_fee : "",
  };
